import { $$ } from './HelperFunctions'
import { tns } from 'tiny-slider/src/tiny-slider'

export class ImageGallery {
  constructor () {
    this.selectors = {
      tinySlider: '.image-gallery .tiny-slider'
    }

    this.tinySliders = $$(this.selectors.tinySlider)
  }

  init () {
    this.tinySliders.forEach(slider => {
      tns({
        container: slider,
        items: 1,
        slideBy: 1,
        responsive: {
          768: {
            gutter: 20,
            items: 2,
            slideBy: 2
          },
          1024: {
            gutter: 30,
            items: 3,
            slideBy: 3
          }
        }
      })
    })
  }
}

export default ImageGallery
